import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TipoLiquidacionService {

  private id!: number;

    set setId(id:number) {
      this.id = id;
    }

    get getId() {
      return this.id;
    }

    constructor(
      private http: HttpClient
    ) { }



    getAll():Observable<BaseDto[]>
    {
      return  this.http.get<BaseDto[]>("/api/TipoLiquidacion/GetAll");
    }

}
